<template>
<div>
  <div class="container container-720">
    <Card>
      <Header class="sub-header" style="margin-bottom:32px;">
        <h3 style="text-align:center;">Login</h3>
      </Header>
      <Form :model="form" label-position="top">
        <FormItem label="Email">
          <Input v-model="form.email" placeholder=""></Input>
        </FormItem>
        <FormItem label="Password">
          <Input type="password" v-model="form.password" placeholder=""></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="login()" style="float:right;" v-if="!$data.isLoginPending">Login</Button>
          <Button type="primary" style="float:right;" disable v-if="$data.isLoginPending">Please wait...</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</div>

</template>

<script>
import {
    mapActions, mapGetters
  } from 'vuex';

  export default {
    name: 'Login',
    data() {
      return {
        form: {},
        isLoginPending: false,
      }
    },
    methods: {
      ...mapActions('auth', [
        'authenticate'
      ]),
      login(){
        this.$set(this.$data, 'isLoginPending', true)

        this.authenticate({
            strategy: 'local',
            email: this.$data.form.email,
            password: this.$data.form.password
          }).then((response)=>{
            this.$router.replace('/');
          }).catch((err)=>{
            if(err.name=="NotAuthenticated"){
              this.$Message.error('Wrong email or password');
            } else {
              this.$Message.error(err.message);
            }
            this.$data.isLoginPending = false;
          })
      },
    }
  }
</script>

<style>

</style>
